import { MOUSE_OVER_DASHBOARD } from '../config/constants';
import * as THREE from 'three';
const initialState = {
  mouseOverDashboard: false
};

const reducer = (state = initialState, action) => {
  const { data } = action;
  switch (action.type) {
    case MOUSE_OVER_DASHBOARD:
      return { ...state, mouseOverDashboard: data };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/ui.js